import { render, staticRenderFns } from "./Origin.vue?vue&type=template&id=1911ae20"
import script from "./Origin.vue?vue&type=script&lang=js"
export * from "./Origin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports